import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Support from "@/pages/Support";
import Stats from "@/pages/Stats";
import Launch from "@/pages/Launch";
import AiVirtualTryOn from "@/pages/AiVirtualTryOn";
import AiStylist from "@/pages/AiStylist";
import DigitalCloset from "@/pages/DigitalCloset";
import ShopAndTry from "@/pages/ShopAndTry";
import SpottedALook from "@/pages/SpottedALook";
import HowItWorks from "@/pages/HowItWorks";
import Faq from "@/pages/Faq";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/ai-virtual-try-on" element={<AiVirtualTryOn />} />
          <Route path="/ai-stylist" element={<AiStylist />} />
          <Route path="/digital-closet" element={<DigitalCloset />} />
          <Route path="/shop-and-try" element={<ShopAndTry />} />
          <Route path="/spotted-a-look" element={<SpottedALook />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/launch" element={<Launch />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/support" element={<Support />} />
          <Route path="/stats" element={<Stats />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
